module.exports = __webpack_public_path__ + "static/media/img_02_paper@2x.738386c7.png";